/// Xử lý lỗi API ở FE — gọi trong catch của các chỗ call API.
///
/// Một cửa duy nhất phân loại lỗi:
///  - Lỗi FIELD-LEVEL (RFC 9457 `fields[]`): KHÔNG toast → trả map
///    `{ field: [message] }` để form gắn xuống đúng input (qua AppFormField).
///  - Lỗi CHUNG (server/mạng/business không field): toast góc phải → trả `{}`.
///
/// Dùng: `fieldErrors.value = handleApiError(err)`. Chỗ không có form field thì cứ
/// gọi `handleApiError(err)` và bỏ giá trị trả về (vẫn toast khi cần).
///
/// Gọi trong catch nên chạy SAU `decodeBlobError` (nếu có) → với download/export
/// body lỗi đã là JSON, `apiErrorMessage` đọc được `code` (message cụ thể).
import { toast } from 'vue3-toastify'

import { apiErrorMessage, fieldErrorsFromApiError } from '@/core/api/api-error'

export function handleApiError(err: unknown): Record<string, string[]> {
  const fields = fieldErrorsFromApiError(err)
  if (Object.keys(fields).length > 0) return fields // có field → form lo, không toast
  toast.error(apiErrorMessage(err))
  return {}
}

/// Biến thể LUÔN toast — cho mutation KHÔNG có `AppFormField` để gắn `fields[]`
/// (vd bảng bulk-edit: scenario editor 11 dòng, path lỗi kiểu `scenarios.3.xxx`
/// không khớp input nào). Nếu chỉ dùng `handleApiError`, lỗi field-level sẽ rơi
/// IM LẶNG (map trả về không ai đọc, không toast). Ưu tiên message field-level đầu
/// tiên (đã localize, cụ thể); không có thì message chung.
export function handleApiErrorToast(err: unknown): void {
  const fields = fieldErrorsFromApiError(err)
  const firstFieldMessage = Object.values(fields)[0]?.[0]
  toast.error(firstFieldMessage ?? apiErrorMessage(err))
}
